import { ResolveFn } from '@angular/router';
import {Project} from "../models/project";
import {inject} from "@angular/core";
import {ProjectService} from "../services/project.service";

export const projectResolver: ResolveFn<Project> = (route, state) => {
  const projectId = route.paramMap.get('project');
  return inject(ProjectService).detail(projectId!);
};
